export function initThemeToggle() {
  const currentTheme =
    localStorage.getItem("theme") ||
    document.documentElement.getAttribute("data-bs-theme") ||
    "dark";
  applyTheme(currentTheme);

  const toggleBtn = document.getElementById("theme-toggle-btn");
  if (toggleBtn) {
    toggleBtn.addEventListener("click", (e) => {
      e.preventDefault();
      const activeTheme = document.documentElement.getAttribute("data-bs-theme") || "dark";
      const nextTheme = activeTheme === "dark" ? "light" : "dark";
      applyTheme(nextTheme);
      localStorage.setItem("theme", nextTheme);
    });
  }
}

export function applyTheme(theme) {
  document.documentElement.setAttribute("data-bs-theme", theme);
  const icon = document.getElementById("theme-toggle-icon");
  const text = document.getElementById("theme-toggle-text");

  if (icon) {
    if (theme === "dark") {
      icon.className = "bi bi-moon-stars-fill";
    } else {
      icon.className = "bi bi-sun-fill";
    }
  }

  if (text) {
    text.textContent = theme === "dark" ? "Dark Mode" : "Light Mode";
  }

  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent("themeChanged", { detail: { theme } }));
  }
}

if (typeof document !== "undefined") {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initThemeToggle);
  } else {
    initThemeToggle();
  }
}
